import { useEffect, useState } from "react";
import api from "../api";

/**
 * Which collection dates VectorSurv says are finished, live: the same rule the
 * watcher emails on (a date is finished once two later dates have been entered),
 * so the screen and the email cannot disagree. Replaces the Google Sheet where
 * Jovana typed that a day was done.
 */

interface ReadyDate {
  date: string;
  label: string;
  rows: number;
  ready: boolean;
  newer: number;
  in_order: boolean;
  last_touch_text: string;
  why: string;
}

export default function AbundanceReadyNow() {
  const [dates, setDates] = useState<ReadyDate[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    api
      .get("/abundance-ready")
      .then((r) => live && setDates(r.data.dates))
      .catch((e) => live && setError(e?.response?.data?.message || "Could not read VectorSurv."));
    return () => {
      live = false;
    };
  }, []);

  return (
    <div className="ui-card p-4" data-testid="abundance-ready-now">
      <h3 className="font-extrabold text-[15px]">Ready to report, from VectorSurv</h3>
      <p className="text-ink-soft text-[13px] mt-1">
        A collection date is finished once two later dates have been entered. Amy is emailed when one
        becomes ready; this shows the same thing live.
      </p>
      {error && <p className="text-[13px] text-wnv mt-2">{error}</p>}
      {!error && !dates && <p className="text-[13px] text-ink-faint mt-2">Reading VectorSurv…</p>}
      {dates && (
        <div className="mt-2 rounded-lg border border-slate-200 overflow-hidden">
          <table className="w-full text-[13px]">
            <tbody>
              {dates.map((d) => (
                <tr key={d.date} className="border-t border-slate-200 first:border-t-0">
                  <td className="px-3 py-1.5 font-medium whitespace-nowrap">{d.label}</td>
                  <td className="px-3 py-1.5 text-slate-500">{d.rows.toLocaleString()} rows</td>
                  <td className="px-3 py-1.5 text-slate-500">last entered {d.last_touch_text}</td>
                  <td className="px-3 py-1.5 text-right whitespace-nowrap">
                    {d.ready ? (
                      <span className="pill bg-brand-tint text-brand-deep">ready</span>
                    ) : (
                      <span className="pill bg-sle-tint text-sle">
                        {d.newer === 0 ? "newest — may still be entered" : "one more date needed"}
                      </span>
                    )}
                    {d.ready && !d.in_order && (
                      <span className="pill bg-wnv-tint text-wnv ml-1" title="Touched after the next date began">
                        entered out of order
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
